var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var CustomTooltip = function (_a) {
    var active = _a.active, payload = _a.payload, label = _a.label;
    if (active && payload && payload.length) {
        return (_jsx("div", __assign({ className: "custom-tooltip", style: { backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' } }, { children: _jsx("p", __assign({ className: "label" }, { children: "\u0412\u044B\u0440\u0443\u0447\u043A\u0430 \u0437\u0430 ".concat(label, ": ").concat(payload[0].value, " \u0440\u0443\u0431.") })) })));
    }
    return null;
};
export default CustomTooltip;
